<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i
      class="fa"
      [ngClass]="{ 'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise }"
      style="margin-right: 10px; cursor: pointer;"
      (click)="minimise = !minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (isLoading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!isLoading) {
<div>
    <div class="comments-field">
      <label><strong>Comments:</strong></label>
      <textarea class="form-control" [ngModel]="COMMENTS" (ngModelChange)="COMMENTS = $event" maxlength="3998"></textarea>
      <div class="textarea-allowed">Max 2000</div>
    </div>

    <table class="table table-bordered custom-table comments-table">
      <thead>
        <tr>
          <th width="50%">Comment</th>
          @if (rowData?.SCENARIO_TYPE_CODE === 'EXAM') {
<th>Issue ID</th>
}
          @if (rowData?.SCENARIO_TYPE_CODE === 'EXAM') {
<th>Scenario</th>
}
          <th width="15%">Logged By</th>
          <th width="15%">Logged On</th>
        </tr>
      </thead>
      <tbody>
        @for (comment of allComments; track $index) {
<tr>
          <td style="word-wrap: break-word">{{ comment.DETAIL_COMMENTS }}</td>
          @if (rowData?.SCENARIO_TYPE_CODE === 'EXAM') {
<td>{{ comment.ISSUE_ID }}</td>
}
          @if (rowData?.SCENARIO_TYPE_CODE === 'EXAM') {
<td>{{ comment.SCENARIO }}</td>
}
          <td>{{ comment.UPDATED_BY }}</td>
          <td>{{ comment.UPDATED_ON }}</td>
        </tr>
}
      </tbody>
    </table>
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="isSaveClicked" (click)="save()">
    @if (isLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
